
import { SortAsc, SortDesc } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

export type SortOption = "name-asc" | "name-desc" | "price-asc" | "price-desc";

interface SortMenuProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  sortBy: SortOption;
  setSortBy: (option: SortOption) => void;
}

export function SortMenu({ open, setOpen, sortBy, setSortBy }: SortMenuProps) {
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-8 w-8 shrink-0"
          aria-label="Sort products"
        >
          {sortBy.includes('asc') ? (
            <SortAsc className="h-4 w-4" />
          ) : (
            <SortDesc className="h-4 w-4" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px] p-2 rounded-xl">
        <DropdownMenuLabel className="font-semibold">Sort By</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-border" />
        <DropdownMenuItem 
          className="rounded-full cursor-pointer"
          onClick={() => setSortBy("name-asc")}
        >
          <SortAsc className="mr-2 h-4 w-4" aria-hidden="true" /> 
          Name (A-Z)
          {sortBy === "name-asc" && (
            <span className="absolute right-2 h-2 w-2 bg-primary rounded-full" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem 
          className="rounded-full cursor-pointer"
          onClick={() => setSortBy("name-desc")}
        >
          <SortDesc className="mr-2 h-4 w-4" aria-hidden="true" /> 
          Name (Z-A)
          {sortBy === "name-desc" && (
            <span className="absolute right-2 h-2 w-2 bg-primary rounded-full" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem 
          className="rounded-full cursor-pointer"
          onClick={() => setSortBy("price-asc")}
        >
          <SortAsc className="mr-2 h-4 w-4" aria-hidden="true" /> 
          Price (Low to High)
          {sortBy === "price-asc" && (
            <span className="absolute right-2 h-2 w-2 bg-primary rounded-full" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem 
          className="rounded-full cursor-pointer"
          onClick={() => setSortBy("price-desc")}
        >
          <SortDesc className="mr-2 h-4 w-4" aria-hidden="true" /> 
          Price (High to Low)
          {sortBy === "price-desc" && (
            <span className="absolute right-2 h-2 w-2 bg-primary rounded-full" />
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
